var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEggplant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "35.496%",
    x2: "43.73%",
    y1: "31.225%",
    y2: "76.478%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F1AAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D970D4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M10.101 2.344c-1.018 1.507-.08 2.764-3.733 3.59-1.621.366-2.957.262-4.345 1.292C.09 8.662-.285 12.072 1.686 13.87c4.614 3.98 13.023-.97 14.16-8.553.756-5.056.985-5.787.687-2.194"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M2 4.756c1.754-3.8 6.567-3.715 8.569 0 2.001 3.715-1.784 2.477-2.795 1.11-.39 3.032-2.688 3.616-3.158.093-.844 1.41-3.937 2.896-2.617-1.203z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5 4.338)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA58B4",
    d: "M14.453 5.802c-.84 2.361-2.766 4.414-5.778 6.16-4.216 2.445-7.333.23-8.446-.785.524 3.306 5.497 4.928 8.446 3.797 4.433-1.7 7.989-8.046 7.989-11.392 0-2.175-8.534-1.702-7.164 0 .203.252.172-.092.969 0-.155 1.015.156 2.33.968 2.69.945.417 1.95.26 3.016-.47z",
    mask: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE9FF",
    d: "M.812 11.568c.688-3.375 2.76-3.686 4.625-4.062 1.867-.377 3.14-.716 3.992-2.38.567-1.11.78-1.702.638-1.774l-.638.672-1.454 1.101L1.93 6.79.344 9.697c-.146 3.497.01 4.121.468 1.871z",
    mask: "url(#c)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.2 1.2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#98E87B",
    transform: "rotate(29 6.41 5.158)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#62BD49",
    strokeWidth: 2,
    d: "M1.91 2.443c4.572-3.993 8.75-.464 8.75 3.95 0 4.414-2.913 1.999-3.278 0-1.836 2.495-4.403 2.093-3.089-1.26-1.6.715-5.567.295-2.383-2.69z",
    mask: "url(#e)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#31323D",
    strokeWidth: 1.5,
    d: "M11.418 6.561c-.503 1.31-.316 2.404-3.584 3.164-1.724.401-3.144.288-4.62 1.415-2.058 1.57-2.455 5.302-.359 7.269 4.73 4.196 13.355-.539 15.037-8.325"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#31323D"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M16.66 4.028c.784-1.59 1.597-1.803 2.453-1.803"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.582 3.722c3.6-2.616 8.07-.035 8.035 4.454-.035 4.49-2.947 1.373-3.192-.421-1.926 2.611-4.381 1.959-3.009-1.556-1.516.87-5.181.643-1.834-2.477z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggplant);
export default __webpack_public_path__ + "static/media/eggplant.143e6b247043d89b431178c16d55305f.svg";
export { ForwardRef as ReactComponent };